import { t } from 'ember-intl';
import pageTitle from 'ember-page-title/helpers/page-title';

<template>
  {{pageTitle (t "recommendations_estimator.forgiveness_estimator")}}
  {{outlet}}
</template>
